import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";
import axios from 'axios';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const Manage_Tracking = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [schedule, setSchedule] = useState(null);


    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = () => {
        const params = {
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id,
            schedule_id: schedule ? schedule.value : null,
        };
        axios.get(`${baseURL}/delivery_tracking/list`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage, schedule]);


    const [optionsSchedule, setOptionsSchedule] = useState([]);
    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await axios.get(`${baseURL}/item-schedule/items/active`);
                if (response.status === 200 && response.data.data) {
                    const schedules = response.data.data.map(item => ({
                        value: item.sno,
                        label: item.itemschedule_name,
                    }));
                    setOptionsSchedule(schedules);
                    // setSchedule(schedules[schedules.length - 1]);
                }
            } catch (error) {
                console.error('Error fetching schedules:', error);
            }
        };

        fetchSchedules();
    }, []);

    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
    }).replace(/ /g, '-'); // converts "12 Aug 2025" -> "12-Aug-2025"


    // -------------------------------------------------- export -----------------------------------//
    
    const exportCSV = async () => {
        try {
            
            const params = {
                search: searchTerm,
                per_page: 'all',
                branch_id: parseInt(localStorage.getItem("branch_id"), 10)
            };

            const response = await axios.get(`${baseURL}/delivery_tracking/list`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Delivery Boy','Mobile No', 'Delivery Point', 
                'Start Time', 'End Time', 'Start Km', 'End Km', 'Total km', 
                'Amount'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Delivery Boy': item.delivery_boy_name,
                'Mobile No': item.delivery_boy_number,
                'Delivery Point': item.dp_name,
                'Start Time': item.start_time_12h || '-',
                'End Time': item.end_time_12h || '-',
                'Start Km': item.start_km || '-',
                'End Km': item.end_km || '-',
                'Total km': item.total_km || '-',
                'Amount': item.amount || '-'
            }));
            const csv = Papa.unparse({
                fields: columnNames,
                data: formattedData
            });
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'tracking.csv';
            link.click();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {
            const params = {
                search: searchTerm,
                per_page: 'all',
                branch_id: parseInt(localStorage.getItem("branch_id"), 10)
            };

            const response = await axios.get(`${baseURL}/delivery_tracking/list`, { params });
            const allData = response.data.data;

            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Delivery Boy': item.delivery_boy_name,
                'Mobile No': item.delivery_boy_number,
                'Delivery Point': item.dp_name,
                'Start Time': item.start_time_12h || '-',
                'End Time': item.end_time_12h || '-',
                'Start Km': item.start_km || '-',
                'End Km': item.end_km || '-',
                'Total km': item.total_km || '-',
                'Amount': item.amount || '-'
            }));
        
            // Create worksheet from formatted data
            const ws = XLSX.utils.json_to_sheet(formattedData);
        
            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
            // Write the workbook to an Excel file and trigger the download
            XLSX.writeFile(wb, 'tracking.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const print = async () => {
        try{
            const params = {
                search: searchTerm,
                per_page: 'all',
                branch_id: parseInt(localStorage.getItem("branch_id"), 10)
            };

            const response = await axios.get(`${baseURL}/delivery_tracking/list`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Delivery Boy','Mobile No', 'Delivery Point', 
                'Start Time', 'End Time', 'Start Km', 'End Km', 'Total km', 
                'Amount'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Delivery Boy': item.delivery_boy_name,
                'Mobile No': item.delivery_boy_number,
                'Delivery Point': item.dp_name,
                'Start Time': item.start_time_12h || '-',
                'End Time': item.end_time_12h || '-',
                'Start Km': item.start_km || '-',
                'End Km': item.end_km || '-',
                'Total km': item.total_km || '-',
                'Amount': item.amount || '-'
            }));

            // Create an HTML table for printing
            let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                <thead>
                    <tr style="background-color: #f2f2f2;">`;

            // Add column headers
            columnNames.forEach(col => {
                printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
            });

            printContent += `</tr></thead><tbody>`;

            // Add the rows of data
            formattedData.forEach(row => {
                printContent += `<tr>`;
                columnNames.forEach(col => {
                    printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
                });
                printContent += `</tr>`;
            });

            printContent += `</tbody></table>`;

            // Open the print dialog
            const printWindow = window.open('', '', 'height=800,width=1000');
            printWindow.document.write('<html><head><title>Lead Details</title>');
            printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close(); // Necessary for IE >= 10
            printWindow.print();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Tracking</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Delivery Management</li>
                    </ol>
                </div>
                <div className='d-flex'>
                    
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i class="fa-solid fa-circle-down fs-8"></i></span>
                            <span className='fw-bold'>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={exportCSV}><label className='text-black'>
                                <span><i class="fa-solid fa-file-csv me-2 fs-4"></i></span>CSV
                            </label></Dropdown.Item>
                            <Dropdown.Item onClick={exportExcel}><label className='text-black'>
                                <span><i class="fa-solid fa-file-excel me-2 fs-4"></i></span>Excel
                            </label></Dropdown.Item>
                            <Dropdown.Item onClick={print}><label className='text-black'>
                                <span><i class="fa-solid fa-print me-2 fs-4"></i></span>Print
                            </label></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <Row className='mb-4'>
                <Col xl={3} >
                    <div>
                        <label className="text-black font-w500 fs-7">Schedule</label>
                        <Select
                            placeholder="Select Schedule"
                            options={optionsSchedule}
                            value={schedule}
                            onChange={setSchedule}
                        />
                    </div>
                </Col>
                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Row>
                            <label className='fs-6 mb-2 font-w600 text-danger text-end'>{formattedDate}</label>
                            <Col xl={12}>
                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{  fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{  fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table style={{ borderBottom: '2px solid #ddd'}} className=" table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px'>Delivery Boy</th>
                                                <th className='min-w-125px text-start'>Delivery point</th>
                                                <th className='min-w-100px text-start'>Time</th>
                                                <th className='min-w-100px text-center'>Start Km</th>
                                                <th className='min-w-125px text-center'>End Km</th>
                                                <th className='min-w-100px text-center'>Total Km</th>
                                                <th className='min-w-100px text-end'>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {datas.length === 0 && hasFetched ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center text-muted py-2">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {datas.map((data, index) => (
                                                        <tr key={data.sno}>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{data.delivery_boy_name}</label>
                                                                <label className='text-grey-800 font-w400 fs-8 d-block'>{data.delivery_boy_number}</label>
                                                            </td>
                                                            <td className='text-start'>
                                                                <label className='text-black font-w400 fs-7'>{data.dp_name}</label>
                                                            </td>
                                                            <td className='text-start'>
                                                                <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Start Time</span></Tooltip>} >
                                                                    <label className='text-green font-w500 fs-7'>{data.start_time_12h}</label>
                                                                </OverlayTrigger>
                                                                <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>End Time</span></Tooltip>} >
                                                                    <label className='text-danger font-w500 fs-7 d-block'>{data.end_time_12h}</label>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td className='text-center'>
                                                                <Badge bg="none" className='text-primary border-primary fs-8 py-0 px-1'>{data.start_km}km</Badge>
                                                            </td>
                                                            <td className='text-center'>
                                                                <Badge bg="none" className='text-danger border-danger fs-8 py-0 px-1'>{data.end_km}km</Badge>
                                                            </td>
                                                            <td className='text-center'>
                                                                <Badge bg="none" className='text-info border-info fs-8 py-0 px-1'>{data.total_km}km</Badge>
                                                            </td>
                                                            <td className='text-end'>
                                                                <label className='text-danger font-w500 fs-7'>
                                                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                                    <span> {data.amount}</span>
                                                                </label>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ):(
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>
                                        
                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                {/* Previous Button */}
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                    Previous
                                                </button>
                                                </li>

                                                {/* First Page */}
                                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                    1
                                                </button>
                                                </li>

                                                {/* Left Ellipsis */}
                                                {page > 4 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Pages Around Current */}
                                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                .map(p => (
                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                        {p}
                                                    </button>
                                                    </li>
                                                ))}

                                                {/* Right Ellipsis */}
                                                {page < totalPages - 3 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Last Page */}
                                                {totalPages > 1 && (
                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                    {totalPages}
                                                    </button>
                                                </li>
                                                )}

                                                {/* Next Button */}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                    Next
                                                </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )


}
export default Manage_Tracking;